module.exports = __webpack_public_path__ + "static/media/no-users.f2f4841e.svg";